var Connection = require('connection');
var IRCFormatter = require('ircformatter');
var util = require('../../lib/util.es6');


var JoinDefaultServersMixins = {
    initialize: function (options) {
        this.joinRealName = this.$('.joinDefaultRealName');
        this.joinName = this.$('.joinDefaultName');
        this.joinForm = this.$('.joinDefaultForm');
        this.joinConnectionsWrapper = this.$('.joinDefaultConnectionsWrapper');
        this.joinConnections = this.$('.joinDefaultConnections');
        this.joinExplanation = this.$('.joinDefaultExplanation');
        this.joinAlready = this.$('.joinDefaultAlready');
        this.joinError = this.$('.joinDefaultError');
    },
    events: {
        'submit .joinDefaultForm': 'submitJoinForm',
        'change p.revealPass input[type=checkbox]': 'changeRevealPass',
        'click .network .matchConn a.chan': 'clickChan',
        'buttonClick .network .matchConnChoice .matchConnTitle': 'clickConnTitle'
    },
    changeRevealPass: function (e) {
        var t = $(e.target);
        t.closest('.network').find('.revealPass').toggleClass('revealed', t.is(':checked'));
    },
    clickChan: function (e) {
        e.preventDefault();
        var t = $(e.target);
        var isChosen = t.hasClass('chosen');
        var chName = t.data('name');
        t.closest('.channels').find('.matchConn a.chan').each(function () {
            if ($(this).data('name') === chName) {
                $(this).toggleClass('chosen', !isChosen);
            }
        });
    },
    clickConnTitle: function (e) {
        e.preventDefault();
        var t = $(e.target);
        var cid = t.data('cid');
        var wrapper = t.closest('.network');
        wrapper.find('.matchConnChoice button.matchConnTitle').removeClass('active');
        wrapper.find('.matchConn').removeClass('active');
        wrapper.find('.matchPass').removeClass('active');
        wrapper.find('.matchConn input').prop('disabled', true);
        if (cid) {
            wrapper.find('.matchConnChoice button.matchConnTitle.c' + cid).addClass('active');
            wrapper.find('.matchConn.c' + cid).addClass('active');
            wrapper.find('.matchConn.c' + cid + ' input').prop('disabled', false);
            wrapper.find('.matchPass.c' + cid).addClass('active');
        } else {
            wrapper.find('.matchConnChoice button.matchConnTitleNone').addClass('active');
            wrapper.find('.matchConnNone').addClass('active');
            wrapper.find('.matchConnNone input').prop('disabled', false);
        }
    },

    renderChannelMatchConn: function (connId, c, active, admin, mc, org) {
        var channels = util.parseChannels(c.channels, c.ircd);
        var matchConn = $('<div class="matchConn">');
        matchConn.toggleClass('active', active);

        if (mc) {
            matchConn.addClass('c' + mc.getCid());
            matchConn.data('cid', mc.getCid());
            matchConn.data('server_pass', c.server_pass);
        } else {
            if (c.ircd) {
                matchConn.addClass('matchConnIrcd');
            }
            matchConn.addClass('matchConnNone');
            matchConn.data('connId', connId);
            if (!admin || org.hasSubscribed()) {
                var nick = this.model.getNick();
                var nickId = 'matchConnNick_' + connId;
                var nickInput = $('<input class="nick input" name="nick[' + connId + ']">').val(nick).attr('id', nickId);
                if (!active) {
                    nickInput.prop('disabled', true);
                }
                var nickLabel = $('<label>').text('Choose a nickname').attr('for', nickId);
                matchConn.append($('<p class="form matchConnNick">')
                    .append(nickLabel)
                    .append('<br>')
                    .append(nickInput));
            }
        }
        var chans = $('<div class="chans">');
        _.each(channels, function (ch) {
            var chParts = ch.split(' ');
            var data = {
                name: chParts[0],
                pass: chParts[1]
            };
            var chan;
            if (org.isAdmin() && !org.hasSubscribed()) {
                chan = $('<strong class="chan found">');
            } else if (mc) {
                var chanMatch = mc.buffers.channels.find(function (ach) {
                    return (
                        ach.isActive() &&
                        data.name.toLowerCase() == ach.getName().toLowerCase()
                    );
                });
                if (chanMatch) {
                    if (!org.haveJoined()) {
                        this.joinAlready.show();
                    }
                    chan = $('<strong class="chan found">');
                }
            }
            if (!chan) {
                chan = $('<a class="chan chosen" href="">');
            }
            chan.text(data.name).data(data);
            if (data.pass) {
                chan.addClass('pass');
                chan.prepend('<i class="fa fa-lock">');
                chan.attr('title', 'Password: ' + data.pass);
            }
            chans.append(chan);
        }, this);

        matchConn.append(chans);
        return matchConn;
    },
    focusNick: function () {
        this.$('input.nick').focus().select();
    },
    renderChannelMatches: function (connId, c, matchingConns, admin, org) {
        var nodes = $('<div class="matchConnNodes">');

        var matchConnChoiceText = $('<p class="matchConnChoiceExplanation">');
        if (c.server_pass) {
            matchConnChoiceText.html('You’re already connected to a similar network with a different <b>password</b>. How would you like to proceed?');
            matchConnChoiceText.addClass('password');
        } else {
            matchConnChoiceText.html('You’re already connected to a similar network on a different <b>port</b>. How would you like to proceed?');
        }
        var matchConnChoice = $('<div class="matchConnChoice">');
        nodes.append(matchConnChoiceText, matchConnChoice);
        _.each(matchingConns, function (mc, i) {
            var isActive = i === 0;
            var cid = mc.getCid();
            var matchConnButton = $('<button type="button" class="matchConnTitle">').data('cid', cid).addClass('c' + cid);
            var matchConnText, matchConnLabel;
            if (c.server_pass) {
                matchConnText = 'Update ';
                matchConnLabel = mc.getName();
            } else {
                matchConnText = 'Join on ';
                matchConnLabel = mc.getHost(true);
            }
            var matchConnTitle = $('<span class="matchConnLabel">').text(matchConnText).append($('<b>').text(matchConnLabel));
            if (mc.isSSL()) {
                matchConnTitle.prepend('<i class="fa fa-shield" title="Secure connection"> ');
            } else {
                matchConnTitle.prepend('<i class="fa fa-globe"> ');
            }
            matchConnButton.toggleClass('active', isActive);
            matchConnChoice.append(matchConnButton.append(matchConnTitle));
            var matchConn = this.renderChannelMatchConn(connId, c, isActive, admin, mc, org);
            nodes.append(matchConn);
        }, this);

        // Don't use a match
        var matchConnButtonNone = $('<button type="button" class="matchConnTitle matchConnTitleNone">');
        var matchConnTitleNone = $('<span>').text('Add a new network');
        matchConnChoice.append(matchConnButtonNone.append(matchConnTitleNone));
        var matchConnNone = this.renderChannelMatchConn(connId, c, false, admin, null, org);
        nodes.append(matchConnNone);
        return nodes;
    },
    findPerfectMatch: function (matchingConns, c, org) {
        var perfectMatch = null;
        if (matchingConns.length) {
            var filteredConns = _.filter(matchingConns, function (mc) {
                return mc.get('server_pass') == c.server_pass;
            });
            if (filteredConns.length) {
                perfectMatch = _.find(filteredConns, function (mc) {
                    return mc.getPort() == c.port;
                })
                || _.find(filteredConns, function (mc) {
                    var ports = [mc.getPort()-0, c.port-0];
                    return _.include(ports, Connection.defaultPort) && _.include(ports, Connection.defaultSSLPort);
                });
            }
        }
        return perfectMatch;
    },
    renderConnection: function (c, i, admin, org) {
        var row = $('<div class="network">').data('index', i);

        // Host
        var hostLine = $('<p class="head">');
        if (admin) {
            hostLine.append('<small class="delete edit"><a href="" class="delete">remove</a></small> ');
        }
        if (c.ircd) {
            row.addClass('ircd');
            hostLine.addClass('ircd');
        }
        if (c.ssl) {
            hostLine.addClass('ssl');
            hostLine.append('<i class="fa fa-shield" title="Secure connection">');
        } else {
            hostLine.append('<i class="fa fa-globe">');
        }
        if (c.ircd) {
            hostLine.append($('<span class="host">').text(' ' + org.get('name') + ' '));
        } else {
            hostLine.append($('<span class="host">').text(' ' + c.hostname + ':' + c.port + ' '));
        }
        row.append(hostLine);

        if (admin && c.ircd) {
            var removeIrcdConfirm = $('<div class="userInfo" id="orgRemoveIrcdConfirm">');
            removeIrcdConfirm.append($('<p>').text('Are you sure you want to remove these default channels'));
            removeIrcdConfirm.append($('<p>')
                .append('<button class="cancel" type="button"><span>Cancel</span></button>')
                .append('<button class="delete" type="button"><span>Yes, we don’t need them anymore</span></button>')
            );
            row.append(removeIrcdConfirm);
        }

        // Channels
        var chanNodes;
        var imperfectMatches = false;
        var matchingConns;
        if (c.ircd) {
            var orgMatch;
            if (org.id) {
                orgMatch = this.model.findOrgConn(org.id);
            } else {
                orgMatch = this.model.findTeamConn();
            }
            if (orgMatch) {
                chanNodes = this.renderChannelMatchConn(i, c, true, admin, orgMatch, org);
            }
        } else {
            matchingConns = this.model.findMatchingConnections(c.hostname);
            var perfectMatch = this.findPerfectMatch(matchingConns, c, org);
            if (perfectMatch) {
                chanNodes = this.renderChannelMatchConn(i, c, true, admin, perfectMatch, org);
            } else if (matchingConns.length) {
                chanNodes = this.renderChannelMatches(i, c, matchingConns, admin, org);
                imperfectMatches = true;
            }
        }
        if (!chanNodes) {
            chanNodes = this.renderChannelMatchConn(i, c, true, admin, null, org);
        }
        var channelLine = $('<div class="channels">').append(chanNodes);
        row.append(channelLine);

        // Server pass
        if (c.server_pass) {
            var passLine = $('<p class="revealPass">')
                .append($('<input type="checkbox">').attr('id', 'orgConnRevealPass' + i))
                .append($('<label>').attr('for', 'orgConnRevealPass' + i).text(' Reveal server password '))
                .append($(' <span class="pass">').text(c.server_pass));
            if (imperfectMatches && matchingConns && matchingConns.length) {
                _.each(matchingConns, function (mc, i) {
                    var isActive = i === 0;
                    var cid = mc.getCid();
                    var matchPassItem = $('<div class="matchPass">').addClass('c' + cid);
                    if (mc.get('server_pass')) {
                        matchPassItem.text('Current ').append($('<span class="pass">').text(mc.get('server_pass')));
                    } else {
                        matchPassItem.append('Current: none');
                    }
                    matchPassItem.toggleClass('active', isActive);
                    passLine.append(matchPassItem);
                });
            }
            row.append(passLine);
            row.addClass('hasPass');
        }
        return row;
    },
    showJoinInit: function (name) {
        this.hideJoinError();
        this.joinAlready.hide();
        this.joinForm.hide();
        this.joinForm.removeData('org');
        this.joinForm.removeSpin();

        this.joinRealName.val(this.model.get('name'));
        this.joinName.text(decodeURIComponent(name));
    },
    showJoinOrg: function (org) {
        this.joinForm.data('org', org);
        if (org.hasConnections() || org.hasIrcd()) {
            var lines = _.map(org.connections, function (c, i) {
                return this.renderConnection(c, i, false, org);
            }, this);
            if (org.hasIrcd()) {
                lines.unshift(this.renderConnection(org.getIrcdConnection(), 'ircd', false, org));
            }
            this.joinConnections.html('').append(lines);
            this.joinConnectionsWrapper.show();
        } else {
            this.joinConnectionsWrapper.hide();
        }
        this.joinForm.show();
    },
    showJoinError: function (response) {
        var msg;
        switch (response.message) {
        case "missing_nickname":
            msg = "Missing nickname";
            break;
        case "invalid_nickname":
            msg = "Invalid nickname";
            break;
        case "redeemed_elsewhere":
            msg = "This invite has already been used";
            break;
        case "org_deleted":
            msg = "This team has been deleted";
            break;
        case "invite_revoked":
            msg = "This invite has been revoked";
            break;
        case "invalid_invite":
            msg = "Invalid team invite";
            break;
        case "already_redeemed":
            msg = 'You’ve already used this <a href="/?/team=' + response.org + '">team</a> invite';
            break;
        case "already_joined":
            msg = 'You’re already a member of this <a href="/?/team=' + response.org + '">team</a>';
            break;
        case "failed_joining_org":
            msg = "Error joining this team";
            break;
        default:
            msg = "Error joining this team: " + IRCFormatter.escapeHtml(response.message);
            break;
        }
        this.joinError.html(msg).fadeIn('fast');
    },
    hideJoinError: function () {
        this.joinError.hide();
    },
    getFoundConns: function () {
        var conns = {};
        this.$('.network .matchConn.active:not(.matchConnNone)').each(function () {
            var key = $(this).data('cid');
            if (!conns[key]) {
                conns[key] = {
                    cid: key,
                    channels: []
                };
            }
            $(this).find('strong.chan.found').each(function () {
                conns[key].channels.push($(this).data('name'));
            });
        });
        var connList = _.map(conns, function (props, cid) {
            props.cid = cid;
            return props;
        });
        return connList;
    },
    getChosenConns: function (context, org, data) {
        var newConns = [];
        var oldConns = {};
        var ircd_channels = [];
        var ircd_nick;
        context.find('.network .matchConn.active').each(function () {
            var d = $.extend({}, $(this).data());
            var key;
            if ('connId' in d) {
                key = d.connId;
                if (key == 'ircd') {
                    $(this).find('a.chan.chosen').each(function () {
                        ircd_channels.push($(this).data('name'));
                        ircd_nick = data['nick[ircd]'];
                    });
                    delete data['nick[ircd]'];
                } else {
                    var fConn = $.extend({}, org.connections[key]);
                    fConn.ssl = !!fConn.ssl;
                    fConn.nick = data['nick[' + key + ']'];
                    delete data['nick[' + key + ']'];
                    delete fConn.channels;
                    newConns[key] = fConn;
                    $(this).find('a.chan.chosen').each(function () {
                        var chanD = $.extend({}, $(this).data());
                        if (!newConns[key].chans) {
                            newConns[key].chans = [];
                        }
                        newConns[key].chans.push(chanD);
                    });
                }
            } else if ('cid' in d) {
                key = d.cid;
                if (!oldConns[key]) {
                    oldConns[key] = {
                        server_pass: d.server_pass
                    };
                }
                $(this).find('a.chan.chosen').each(function () {
                    var chanD = $.extend({}, $(this).data());
                    if (!oldConns[key].chans) {
                        oldConns[key].chans = [];
                    }
                    oldConns[key].chans.push(chanD);
                });
            }
        });
        return {
            'new': _.filter(newConns, _.identity),
            'current': oldConns,
            'ircd_channels': ircd_channels.join(' '),
            'ircd_nick': ircd_nick
        };
    },
    submitJoinForm: function (e) {
        e.preventDefault();
        var data = this.joinForm.serializeForm();
        var org = this.joinForm.data('org');
        var chosen = this.getChosenConns(this.joinForm, org, data);
        data.connections = JSON.stringify(chosen);
        this.hideJoinError();
        this.joinForm.addSpin();
        this.joinDefaultServerAction(data, _.bind(function (response) {
            this.joinForm.removeSpin();
            if (response.success) {
                if (response.cids && response.cids[0]) {
                    this.model.setFocusOnMakeServer(response.cids[0]);
                } else {
                    this.joinDefaultServerEndAction();
                }
            } else {
                this.showJoinError(response);
            }
        }, this));
    }
};


module.exports = JoinDefaultServersMixins;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/mixins/joindefaultserversmixins.js
// module id = KQDl
// module chunks = 1